
export default function cekNumerik(str: any) {
  return (typeof(str) === 'number' || typeof(str) === "string" && str.trim() !== '') && !isNaN(str as number);
}